import PropTypes from "prop-types";
import Link from "../link/Link";
import './LunchInfo.scss';

const LunchInfo = ({lunch}) => {
    const {company, companyUrl, title, description} = lunch;
    return (
        <div className="lunch-info">
            <Link url={companyUrl} text={company}/>
            <p className="lunch-info--title">{title}</p>
            <p className="lunch-info--description">{description}</p>
        </div>
    );
};

LunchInfo.propTypes = {
    lunch: PropTypes.object.isRequired
};

export default LunchInfo;
